import QAInspectionDetail from "../components/inspections/QAInspectionDetail";

export default function QAInspectionDetailPage() {
  return <QAInspectionDetail />;
}